import { type Resource } from 'i18next';
import { Locale } from './types';
import i18n from 'i18next';
import translationFr from './fr.json';
import translationEn from './en.json';
import translationEs from './es.json';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector/cjs';
import config from 'config';

export const DEV_LANG_ENABLED = config.env === 'test' || config.env === 'local';

export const defaultNS = 'translation';

export const resources = {
  [Locale.enGB]: {
    [defaultNS]: translationEn,
  },
  [Locale.enUS]: {
    [defaultNS]: translationEn,
  },
  [Locale.es]: {
    [defaultNS]: translationEs,
  },
  [Locale.fr]: {
    [defaultNS]: translationFr,
  },
  ...(DEV_LANG_ENABLED
    ? {
        [Locale.dev]: {
          translation: {},
        },
      }
    : {}),
} satisfies Resource;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEV_LANG_ENABLED ? undefined : Locale.fr,
    defaultNS,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br'],
    },
  });

export { i18n };
